export default "__VITE_ASSET__94fc9ed2__"